import React from 'react';
import SectionCard from '../SectionCard';
import './ChatsTab.css';

const ChatsTab = ({ appData, onToggleFavorite }) => {
  // Чаты - это отдельный раздел с shortname "chats"
  const chatsSection = appData?.sections.find(s => s.shortname === 'chats');
  
  if (!chatsSection) {
    return (
      <div className="chats-tab">
        <div className="section-header">
          <h2>Основные чаты</h2>
        </div>
        <p>Раздел чатов пока не создан</p>
      </div>
    );
  }

  const handleChatClick = (material) => {
    if (material.external_link) {
      window.open(material.external_link, '_blank', 'noopener,noreferrer');
    }
  };

  // Преобразуем материалы в формат разделов для использования SectionCard
  const chatSections = chatsSection.materials.map(material => ({
    id: material.id,
    title: material.title,
    description: material.description,
    image: material.image,
    external_link: material.external_link,
    text_color: material.text_color
  }));

  return (
    <div className="chats-tab">
      <div className="section-header">
        <h2>Основные чаты</h2>
      </div>
      <div className="chats-grid">
        {chatSections.map(section => (
          <SectionCard
            key={section.id}
            section={section}
            onClick={() => handleChatClick(section)}
            className="chat-section-card"
            isChat={true}
          />
        ))}
      </div>
    </div>
  );
};

export default ChatsTab; 